import React from 'react';
import { Hero } from '../components/home/Hero';
import { QuickFacts } from '../components/home/QuickFacts';
import { UpcomingEvents } from '../components/home/UpcomingEvents';
import { TypicalWeek } from '../components/schedule/TypicalWeek';
import { ScheduleChannels } from '../components/schedule/ScheduleChannels';
import { WhoWeAre } from '../components/home/WhoWeAre';
import { Mission } from '../components/home/Mission';
import { FirstThursday } from '../components/home/FirstThursday';
import { PhotoMosaic } from '../components/home/PhotoMosaic';
import { WelcomeVideo } from '../components/home/WelcomeVideo';
import { FinalCta } from '../components/home/FinalCta';
export function Home() {
  return <>
      <Hero data-id="element-619" data-mp="2diruazifuxzm" />
      <QuickFacts data-id="element-620" data-mp="2dii2d6du2gra" />
      <UpcomingEvents data-id="element-621" data-mp="2dj1nevys5l9j" />
      <TypicalWeek data-id="element-622" data-mp="3kvafowjiyu0a" />
      <ScheduleChannels data-id="element-623" data-mp="3kvtn3jbju002" />
      <WhoWeAre data-id="element-624" data-mp="3kuihrf2ggk6u" />
      <Mission data-id="element-625" data-mp="3kv0nd2b0carf" />
      <FirstThursday data-id="element-626" data-mp="3kxd5pgkogn50" />
      <PhotoMosaic data-id="element-627" data-mp="3owlus84rvwu8" />
      <WelcomeVideo data-id="element-628" data-mp="3ow419j9hvwq0" />
      <FinalCta data-id="element-629" data-mp="3ovkhry47509v" />
    </>;
}